export default __webpack_public_path__ + "static/media/dna-bg.89a156c0.png";